var map = {
	"./bg-service-modulesC.png": 489,
	"./bg-service-modulesD1.png": 490,
	"./bg-service-modulesD2.png": 491,
	"./bg-service-modulesD3.png": 492,
	"./bg-service-modulesD4.png": 493,
	"./bg-service-modulesD5.png": 494,
	"./bg-service-modulesD6.png": 495,
	"./bg-service-modulesD7.png": 496,
	"./bg-service-modulesD8.png": 497,
	"./black-triangle.png": 498,
	"./icon-service-modulesA1.png": 499,
	"./icon-service-modulesA2.png": 500,
	"./icon-service-modulesA3.png": 501,
	"./icon-service-modulesA4.png": 502,
	"./icon-service-modulesB1.png": 503,
	"./icon-service-modulesB2.png": 504,
	"./icon-service-modulesB3.png": 505,
	"./yellow-triangle.png": 506
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 488;